import {jwtDecode} from 'jwt-decode';

interface DecodedToken {
    // Define the structure of your decoded token here
    userId: string;
    exp: number;
    iat: number;
    email: string;
    name: string;
    // Add other fields as necessary
}

export const getDecodedAccessToken = (): DecodedToken | null => {
    const token = localStorage.getItem('accessToken') ?? sessionStorage.getItem("accessToken");
    
    if (!token) {
        return null;
    }

    try {
        const decodedToken: DecodedToken = jwtDecode(token);        
        return decodedToken;
    } catch (error) {
        console.error('Failed to decode token:', error);
        return null;
    }
};

export const formatPriceWithCurrency = (price: string, priceCurrency: string): string => {
    const currencySymbols: { [key: string]: string } = {
        dollar: '$',
        euro: '€',
        GBP: '£',
        yen: '¥'
    };

    const symbol = currencySymbols[priceCurrency];

    return symbol ? `${symbol}${price}` : `${price} ${priceCurrency}`;
};

export const getAccessToken = (key: string): string | null => {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  };
  
